// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"116":"9416b2ac","165":"2348aab5","584":"d70a1c0e","641":"072c2f3f"}[chunkId] + ".css";
};